Bingo.MapOnDetail = {};

Bingo.MapOnDetail.init = function () {
    $('.js-mapOnDetail__labelsControl').removeClass('-opened');
    $('.js-mapOnDetail__labelsControlHeader').click(function () {
        const control = $(this).closest('.js-mapOnDetail__labelsControl');
        control.toggleClass('-opened');
    });
    $('.js-mapOnDetail-tab').click(function () {
        $('.js-mapOnDetail-tab').removeClass('-active');
        $(this).addClass('-active');
        const tab = $(this).data('tab');
        if (tab === 'map') {
            $('.O-mapOnDetail__mapWrap').css('background-color', 'red'); // Code for activate classic map
        }
        if (tab === 'pano') {
            $('.O-mapOnDetail__mapWrap').css('background-color', 'green'); //   Code for activate panorama view
        }
    });
};
